import React, { useState } from "react";
import { IFolder } from "./api/services/file.service";
import { IProject } from "./api/services/project.service";
import { useLocalStorage } from "./hooks/useLocalStorage";

interface InternalStateProps {
  sidebarOpen: boolean;
  setSidebarOpen?: (value: boolean) => void;

  sidebarEnabled: boolean;
  setSidebarEnabled?: (value: boolean) => void;

  theme: string;
  setTheme?: (value: string) => void;

  directplay: boolean;
  setDirectplay: (value: boolean) => void;

  activeProjectRole: string | null;
  setActiveProjectRole: (id: string | null) => void;

  activeProject: IProject | null;
  setActiveProject: (id: IProject | null) => void;

  activeFolders: IFolder[];
  setActiveFolders: (folders: IFolder[]) => void;
}

let GlobalStateContext = React.createContext<InternalStateProps>(null!);

export function GlobalStateProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [theme, setTheme] = useLocalStorage<string>("theme", "light");
  const [directplay, setDirectplay] = useLocalStorage<boolean>(
    "directplay",
    true
  );
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [sidebarEnabled, setSidebarEnabled] = useState<boolean>(false);

  const [activeProject, setActiveProject] = useState<IProject | null>(null);
  const [activeProjectRole, setActiveProjectRole] = useState<string | null>(
    null
  );

  const [activeFolders, setActiveFolders] = useState<IFolder[]>([]);

  let value = {
    sidebarOpen,
    setSidebarOpen,
    sidebarEnabled,
    setSidebarEnabled,
    theme,
    setTheme,
    directplay,
    setDirectplay,
    activeProjectRole,
    setActiveProjectRole,
    activeProject,
    setActiveProject,
    activeFolders,
    setActiveFolders,
  };

  return (
    <GlobalStateContext.Provider value={value}>
      {children}
    </GlobalStateContext.Provider>
  );
}

export function useGlobalState() {
  return React.useContext(GlobalStateContext);
}
